import styled from 'styled-components'
import React from 'react'
import { Button } from 'react-bootstrap'

const DivBox = ({ className, children }) => <div className={className}>{children}</div>

export const DivContentBox = styled(DivBox)`
  border-radius: 0 0 10px 10px;
`

export const DivTitleBox = styled(DivBox)`
  border-radius: 10px 10px 0 0;
`

export const ButtonBackDiv = styled.div`
  margin-bottom: 16px;
`

export const RoundWidgetDiv = styled(DivBox)`
  width: 100px;
  height: 100px;
  background: ${(props) => props.color};
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50px;
  font-size: 20px;
  color: white;
  padding-top: 35px;
  text-align: center;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`

const ButtonLink = ({ className, onClickFunc, onMouseEnterFunc, onMouseLeaveFunc, style, children }) => (
  <Button
    className={className}
    variant='link'
    style={style}
    onClick={onClickFunc}
    onMouseEnter={onMouseEnterFunc}
    onMouseLeave={onMouseLeaveFunc}
  >
    {children}
  </Button>
)

export const ButtonLinkSideMenu = styled(ButtonLink)`
  font-weight: 600;
  padding: 13px 20px 13px 25px;
  text-decoration: none;
  cursor: pointer;
  text-align: left;
  width: 100%;
  font-size: 13px;
  line-height: 1.42857143;
`

export const CalloutBox = styled.div`
  padding: 1.25rem;
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
  border: 1px solid #eee;
  border-left-width: 0.25rem;
  border-radius: 0.25rem;
  border-left-color: #f0ad4e;
`
